module.exports = __webpack_public_path__ + "static/img/act-steps-m-3-hk.00e63d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-3-hk.png
// module id = A2Qv
// module chunks = 1